import { IDeleteDocumentoUseCase } from "../../../presentation/useCases/delete/delete_documento_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * DeleteDocumentoUseCase
 */

export class DeleteDocumentoUseCase implements IDeleteDocumentoUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async deleteDocumento(idDocumento: number): Promise<void> {
    await this.repository.deleteDocumento(idDocumento);
  }
}